<button class="clip3 corner padding-1sm position-relative primary-border secondary-bg secondary-text-100 font-4 rounded-0 py-2_5 px-2_5 fs-5 d-flex align-items-center">
  @if (isLoading()) {
    <div class="spinner-border spinner-border-sm"> <span class="visually-hidden">Loading...</span></div>
  } @else {
    <svg-icon 
      fontSize="26px"
      key="print-solid">
    </svg-icon>
  }
</button>